const ANIMATION_DURATION = 500;

const ARE_KEYBOARD_SHORTCUTS_ENABLED = false;

const COLLECT_ENDPOINT = window.location.protocol + '//' + window.location.host + '/qsbk/contact-message/';

const REQUEST_STATUS = {
  FAILED      : 'REQUEST_STATUS::FAILED',
  IN_PROGRESS : 'REQUEST_STATUS::IN_PROGRESS',
  SUCCEEDED   : 'REQUEST_STATUS::SUCCEEDED'
};

const TRANSITION_DIRECTION = {
  BACKWARD : 'backward',
  FORWARD  : 'forward'
};

export {
  ANIMATION_DURATION,
  ARE_KEYBOARD_SHORTCUTS_ENABLED,
  COLLECT_ENDPOINT,
  REQUEST_STATUS,
  TRANSITION_DIRECTION
};
